<template>
    <v-data-table
        :headers="expenseHeaders"
        :items="invoice.expenses"
        group-by="maintenance_expense_category_id"
        item-key="id"
        class="elevation-1"
        hide-default-footer
        :items-per-page="-1"
    >
        <template v-slot:group.header="{ items, group }">
            <td>
                <v-btn text left color="indigo" @click="toggleGroup(group)">
                    <v-icon>
                        {{ groupOpenState[group] ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                    {{ items[0].category.name }}
                </v-btn>
                <!--<v-tooltip right color="success">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            right
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            @click="downloadExpenseReport(items)"
                        >
                            mdi-file-chart
                        </v-icon>
                    </template>
                    <span
                        >Download
                        {{ items[0].category.name }}
                        Expenses report</span
                    >
                </v-tooltip>-->
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="font-weight-bold">
                {{ expenseTotals(items).subTotalCost }}
            </td>
            <td class="font-weight-bold">{{ expenseTotals(items).tax }}</td>
            <td class="font-weight-bold green--text accent-4--text">
                {{ expenseTotals(items).totalCost }}
            </td>
        </template>
        <template v-slot:item="{ item }">
            <tr v-if="groupOpenState[item.maintenance_expense_category_id]">
                <td>{{ item.category.name }}</td>
                <td>
                    {{ item.subcategory ? item.subcategory.name : 'N/A' }}
                </td>
                <td>{{ item.description }}</td>
                <td>{{ item.comments }}</td>
                <td>{{ item.custom_tax_rate }}</td>
                <td>{{ item.quantity }}</td>
                <td>${{ item.unit_cost }}</td>
                <td class="font-weight-bold">
                    {{
                        item.subtotal_cost
                            ? '$' + item.subtotal_cost
                            : expenseTotals(item).subTotalCost
                    }}
                </td>
                <td class="font-weight-bold">${{ item.tax }}</td>
                <td class="font-weight-bold">${{ item.total_cost }}</td>
            </tr>
        </template>
        <template v-slot:foot="{ items }">
            <td>
                <!--<v-btn
                    color="success"
                    text
                    class="ma-2"
                    @click="downloadExpenseReport(items)"
                >
                    <v-icon left>mdi-chart-box-multiple</v-icon>
                    Download Expense Report
                </v-btn>-->
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="px-3 font-weight-bold text-body-2">
                {{ expenseTotals(items).subTotalCost }}
            </td>
            <td class="px-3 font-weight-bold text-body-2">
                {{ expenseTotals(items).tax }}
            </td>
            <td
                class="px-3 font-weight-bold text-body-1 green--text accent-4--text"
            >
                {{ expenseTotals(items).totalCost }}
            </td>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'InvoiceDetails',
    props: {
        invoice: Object,
        invoiceHeaders: Array,
        expenseHeaders: Array
    },
    filters: {},
    data() {
        return {
            groupOpenState: {}
        };
    },
    mounted() {
        this.invoice.expenses.forEach(item => {
            this.$set(
                this.groupOpenState,
                item.maintenance_expense_category_id,
                false
            );
        });
        console.log('InvoiceDetails Invoice: ', this.invoice);
        console.log('InvoiceDetails InvoiceHeaders: ', this.invoiceHeaders);
        console.log('InvoiceDetails ExpenseHeaders: ', this.expenseHeaders);
    },
    methods: {
        toggleGroup(group) {
            console.log('Group: ', group);
            if (
                Object.prototype.hasOwnProperty.call(this.groupOpenState, group)
            ) {
                this.groupOpenState[group] = !this.groupOpenState[group];
                console.log('Group open state: ', this.groupOpenState);
            } else {
                this.$set(this.groupOpenState, group, true);
            }
        },
        expenseTotals(expenses) {
            //Return total costs and taxes for the expenses
            let totalCost = 0;
            let tax = 0;
            let subTotalCost = 0;
            console.log('Expenses: ', expenses);
            //if there are multiple expenses run the foreach loop to get the total cost and tax else process the single expense that is not an array
            if (expenses.length > 0) {
                expenses.forEach(expense => {
                    //values are in text format, convert to numbers of no more than 2 decimal places, remember that these are currencies
                    let expenseTotalCost = parseFloat(expense.total_cost);
                    let expenseTax = parseFloat(expense.tax);
                    let expenseSubTotalCost = parseFloat(expense.subtotal_cost);
                    totalCost += expenseTotalCost;
                    tax += expenseTax;
                    subTotalCost += expenseSubTotalCost;
                });
            } else {
                let expense = expenses;
                let expenseTotalCost = parseFloat(expense.total_cost);
                let expenseTax = parseFloat(expense.tax);
                let expenseSubTotalCost = parseFloat(expense.subtotal_cost);
                totalCost += expenseTotalCost;
                tax += expenseTax;
                subTotalCost += expenseSubTotalCost;
            }
            totalCost = Math.round(totalCost * 100) / 100;
            tax = Math.round(tax * 100) / 100;
            subTotalCost = Math.round(subTotalCost * 100) / 100;
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            return {
                subTotalCost: formatter.format(subTotalCost),
                totalCost: formatter.format(totalCost),
                tax: formatter.format(tax)
            };
        }
    }
};
</script>
